module.exports = __webpack_public_path__ + "img/e3b1766.jpg";